import { Editor } from 'slate';

import { unhangRange } from '../Transforms/unhangRange';

export const getNodes = (editor, options = {}) => {
  unhangRange(editor, options);

  return Editor.nodes(editor, options);
};
